var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServerCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    width: 24,
    height: 24,
    color: "#22543d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-637b8d40f95e86b59c57a2ff-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "roll_brush",
    "data-name": "roll brush"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8d40f95e86b59c57a2ff-1",
    d: "M22.52,13a2.35,2.35,0,0,1,0,.26,3.82,3.82,0,0,1-3.83,3.57H16.77V13c0,1-2.15,1.92-4.8,1.92S7.17,14,7.17,13v3.83h-1A4.8,4.8,0,0,1,1.43,12.2a1.41,1.41,0,0,1,0-.2,4.78,4.78,0,0,1,4.8-4.8h0A6.68,6.68,0,0,1,6.8,4.68l.13-.26a5.71,5.71,0,0,1,4.83-3H12A5.75,5.75,0,0,1,17.72,7.2V9.12h1A3.84,3.84,0,0,1,22.52,13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-637b8d40f95e86b59c57a2ff-1",
    cx: 11.97,
    cy: 12.96,
    rx: 4.8,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8d40f95e86b59c57a2ff-1",
    d: "M16.77,13v3.83c0,1.06-2.15,1.92-4.8,1.92s-4.8-.86-4.8-1.92V13c0,1,2.15,1.92,4.8,1.92S16.77,14,16.77,13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-637b8d40f95e86b59c57a2ff-1",
    cx: 11.97,
    cy: 12.96,
    rx: 4.8,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8d40f95e86b59c57a2ff-1",
    d: "M16.77,16.79v3.84a1.27,1.27,0,0,1-.65,1,7.88,7.88,0,0,1-4.15,1,7.88,7.88,0,0,1-4.15-1,1.25,1.25,0,0,1-.65-1V16.79c0,1.06,2.15,1.92,4.8,1.92S16.77,17.85,16.77,16.79Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerCloud);
export default __webpack_public_path__ + "static/media/server-cloud.7a48b34c623e6a692edc1377fa26686a.svg";
export { ForwardRef as ReactComponent };